'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSearch = createSearch;
exports.countEstablishmentRequest = countEstablishmentRequest;
exports.getPricesRequest = getPricesRequest;
exports.getEstablishmentsRequest = getEstablishmentsRequest;
exports.getDescriptionRequest = getDescriptionRequest;
exports.getImagesRequest = getImagesRequest;
exports.getPartnersRequest = getPartnersRequest;
exports.getExtraInfo = getExtraInfo;

var _config = require('../config');

var _constants = require('../constants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var searchIdParam = 'session_id';

function getAPILocation() {
  return (0, _config.getConfig)().SEARCH_SERVICE + '/' + _constants.VERSION;
}

function handleRequest(resp) {
  return resp.status >= _constants.HTTP_RESPONSES.OK && resp.status <= _constants.HTTP_RESPONSES.FINISHED ? Promise.resolve(resp).then(function (r) {
    return r.json();
  }) : Promise.reject(new Error(resp.statusText));
}

function endPricesResponse(responseData) {
  if (responseData.data) {
    var data = responseData.data;
    return {
      msg: 'no_data',
      data: _defineProperty({}, searchIdParam, data[searchIdParam])
    };
  }
  return responseData.then(function (data) {
    var _data2;

    return {
      msg: 'no_data',
      data: (_data2 = {}, _defineProperty(_data2, searchIdParam, data.data[searchIdParam]), _defineProperty(_data2, 'search_id', data.data.search_id), _data2)
    };
  });
}

function parseOptions(opts) {
  return Object.keys(opts).map(function (opt) {
    return opt + '=' + opts[opt];
  }).join('&');
}

function createRequest(endpoint, requestOptions) {
  var requestOptionsWithCookies = Object.assign({}, requestOptions, { credentials: 'include' });
  return fetch(endpoint, requestOptionsWithCookies).then(function (response) {
    return response.ok ? response : Promise.reject(Error(response));
  });
}

/**
 * Create Search
 */
function createSearch(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var endpoint = getAPILocation() + '/prices';
  var extraParams = parseOptions(options);
  endpoint = extraParams ? endpoint + '?' + extraParams : endpoint;

  return createRequest(endpoint, {
    method: 'POST',
    body: params
  }).then(function (resp) {
    if (resp.status === _constants.HTTP_RESPONSES.FINISHED) return endPricesResponse(resp.json());
    return handleRequest(resp);
  });
}

/**
 * Get Search total establishments
 */
function countEstablishmentRequest(searchId, sessionId) {
  var endpoint = getAPILocation() + '/count/' + searchId + '?session_id=' + sessionId;
  return createRequest(endpoint).then(handleRequest).then(function (resp) {
    return resp.data;
  });
}

/**
 * Get Search Prices
 */
function getPricesRequest(searchId, sessionId, tms) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var endpoint = getAPILocation() + '/prices/' + searchId + '?session_id=' + sessionId + '&tms=' + tms;
  var extraParams = parseOptions(options);
  endpoint = extraParams ? endpoint + '&' + extraParams : endpoint;

  return createRequest(endpoint).then(function (resp) {
    return resp.status === _constants.HTTP_RESPONSES.NO_CONTENT || resp.status === _constants.HTTP_RESPONSES.FINISHED ? Promise.resolve(resp).then(function (r) {
      return r.json();
    }).then(endPricesResponse) : Promise.resolve(resp).then(function (r) {
      return r.json();
    });
  });
}

function getEstablishmentsRequest(establishmentID) {
  var establishments = establishmentID.join(',');
  var endpoint = getAPILocation() + '/establishments?ids=' + establishments;
  return createRequest(endpoint).then(handleRequest);
}

function getDescriptionRequest(establishmentID) {
  var endpoint = getAPILocation() + '/establishment/' + establishmentID + '/description_translations';
  return createRequest(endpoint).then(handleRequest);
}

function getImagesRequest(establishmentID) {
  var endpoint = getAPILocation() + '/establishment/' + establishmentID + '/images';
  return createRequest(endpoint).then(handleRequest);
}

function getPartnersRequest() {
  var endpoint = getAPILocation() + '/partners';
  return createRequest(endpoint).then(handleRequest);
}

function getExtraInfo(establishmentId) {
  var endpoint = getAPILocation() + '/establishmentdetails/' + establishmentId;
  return createRequest(endpoint).then(handleRequest);
}